<template>
  <validation-observer ref="deliverVardObserver" novalidate tag="form">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class=" fa fa-user-check color-orange" />
        Entregada a Encargado
      </div>
      <div class="col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="model.deliveryDate"
            class="custom-date-picker__extended"
            custom-error-msg="Favor seleccionar Fecha de Entrega."
            :error="errors[0]"
            label="Fecha:"
            :max-date="new Date()"
            :min-date="beforeBankRequestDate"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="model.deliveryMethodId"
            :clearable="false"
            custom-error-msg="Favor seleccionar Método de Entrega."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Método de Entrega:"
            :options="deliveryMethods"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-md-12 mt-2">
        <custom-text-area
          v-model="model.comment"
          class=""
          label="Comentario:"
          :maxlength="500"
          :rows="4"
          show-char-count
        />
      </div>

      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        >
          Cancelar
        </action-button>
        <action-button i="fas fa-save" variant="success" @click="submit">
          Guardar
        </action-button>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@/mixins/alert.mixin';
import { putDelivered } from '@/modules/shared/cardHandling.api';
import { getCardDeliveryMethods } from '@/modules/shared/code.api';
import moment from 'moment';
export default {
  name: 'DeliverCard',
  components: {
    CustomTextArea,
    CustomDatePicker,
    CustomDropDown,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
    bankRequestDate: {
      type: Date,
      default: null,
    },
  },
  data: () => ({
    model: {
      deliveryMethodId: null,
      comment: '',
      deliveryDate: null,
    },
    //Test data for replacement
    deliveryMethods: [],
  }),
  computed: {
    beforeBankRequestDate() {
      return moment(this.bankRequestDate)
        .subtract(1, 'days')
        .toDate();
    },
  },
  mounted() {
    this.getDeliverMethod();
  },
  methods: {
    async submit() {
      this.model.becaCardId = this.id;
      const isValid = await this.$refs.deliverVardObserver.validate();
      if (isValid) {
        let payload = {
          deliveryDate: this.model.deliveryDate,
          deliveryMethodId: this.model.deliveryMethodId.id,
          comment: this.model.comment,
          becaCardId: this.model.becaCardId,
        };
        putDelivered(payload)
          .then(() => {
            this.ShowToast(
              'Confirmación',
              'La entrega ha sido documentada exitosamente.',
              'success'
            );
            this.$emit('on-saved');
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error');
            } else {
              this.ShowToast('Error', err.message, 'error');
            }
          });
      }
    },
    async getDeliverMethod() {
      const deliveryMethods = await getCardDeliveryMethods();
      this.deliveryMethods = deliveryMethods.data;
    },
  },
};
</script>
<style scoped lang="scss"></style>
